import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, retry, timeout } from 'rxjs';
import { AppConfigService } from '@markant-platform/shared/data-access';

export class RetryInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Timeouts are only configured for certain GET requests to prevent side effects
    const organizationById = AppConfigService.appConfiguration.apiUrl['organizationService'] + '/.*?';
    const roleAssignment = AppConfigService.appConfiguration.apiUrl['authorizerService'] + '/user/.*?/role-assignment';
    const priceRequests = AppConfigService.appConfiguration.apiUrl['priceRequestService'];
    const bookedCartridges = AppConfigService.appConfiguration.apiUrl['userCartridgeService'];
    const cartridges = AppConfigService.appConfiguration.apiUrl['leistungService'];
    const cartridgeGroups = AppConfigService.appConfiguration.apiUrl['cartridgeGroupService'];

    const urls = [organizationById, roleAssignment, priceRequests, bookedCartridges, cartridges, cartridgeGroups];

    if (req.method === 'GET' && req.url.match(new RegExp(`(${urls.join('|')})`))) {
      return next.handle(req).pipe(timeout(1500), retry(1));
    }
    return next.handle(req);
  }
}
